function RegisterSection() {
    return (
        <>
            <div className="my-account-area pt-100 pb-70">
                <div className="container">
                    <div className="login-form">
                        <form className="my-account-content register-form" onSubmit={(e)=>e.preventDefault()}>
                            <div className="section-title">
                                <h2>Register</h2>
                                <span className="top-title">Get Start With Us</span>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input required type="text" className="form-control" placeholder="First Name" />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input required type="text" className="form-control" placeholder="Last Name" />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input required type="text" className="form-control" placeholder="User Name" />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input required type="email" className="form-control" placeholder="Email Address" />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input required type="password" minLength={8} className="form-control" placeholder="Password" />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <div className="form-group">
                                        <input required type="file" className="form-control" accept="image/png,image/jpg,image/jpeg,image/gif" />
                                    </div>
                                </div>
                                <div className="col-lg-12">
                                    <button type="submit" className="default-btn btn-style-fore">Register</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RegisterSection